import styled from 'styled-components';

export const FunnelListContainer = styled.div`
  min-height: 300px;
`;
export const NAText = styled.div`
  font-size: 25px;
  font-weight: 600;
  color: rgb(0 0 0 / 25%);
`;
export const FunnelItemContainer = styled.div`
  padding: 16px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
  border-radius: 8px 4px 4px 8px;
  border-left: 8px solid #94a3b8;
  margin-bottom: 8px;

  &:hover {
    background: #f9f9f9;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

export const TagBadge = styled.span`
  background: #e6f4ff;
  color: #1890ff;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
`;

export const BreadcrumbContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
  flex: 1;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
`;

export const MetricColumn = styled.div`
  text-align: left;
  min-width: 80px;
`;

export const MetricValue = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  line-height: 1.2;
  min-height: 24px;
`;

export const MetricLabel = styled.div`
  font-size: 12px;
  color: #677489;
  font-weight: 400;
  margin-top: 2px;
  line-height: 1.2;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #f0f0f0;
    color: #333;
  }
`;

export const BreadcrumbItem = styled.span`
  color: #333;
  font-size: 16px;
  font-weight: 500;
  padding: 4px;

  /* background: #f5f5f5; */
  border-radius: 4px;
  white-space: nowrap;
`;

export const BreadcrumbArrow = styled.span`
  color: #666;
  font-size: 16px;
  font-weight: bold;
  user-select: none;
`;
export const SplitLine = styled.div`
  width: 1px;
  height: 52px;
  background: rgb(0 0 0 / 6%);
`;
